import './FinanciarWizard.scss';

import React, { useState, useMemo } from 'react';

import { useTenant } from '../../context/TenantContext';
import { useFeatureFlags } from '../../context/FeatureFlagsContext';
import StepNav from '../../components/stepnav/StepNav';
import FormContacto from './FormContacto';
import FormCredito from './FormCredito';
import Simulacion from './Simulacion';

// Definición de los pasos del wizard
const ALL_STEPS = [
  { id: 1, label: 'Info de contacto', component: FormContacto },
  { id: 2, label: 'Info del crédito', component: FormCredito },
  { id: 3, label: 'Simulación', component: Simulacion },
];

const FinanciarWizard = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({});
  const { isMeliTenant } = useTenant();
  const { flags, isLoadingFlags } = useFeatureFlags();

  const STEPS = useMemo(() => {
    return isMeliTenant || flags.isAutoConfirmFlow ? ALL_STEPS.slice(0, 2) : ALL_STEPS;
  }, [isMeliTenant, flags]);

  const totalSteps = STEPS.length;

  // Cambiar el paso actual
  const handleStepChange = (stepId) => {
    setCurrentStep(stepId);
  };

  // Ir al siguiente paso, guardando los datos del formulario si es necesario
  const goToNextStep = (newData = {}) => {
    // Combinar los datos actuales con los nuevos
    setFormData((prevData) => ({
      ...prevData,
      ...newData, // Sobreescribir los datos con los nuevos del paso actual
    }));
    // Avanzar al siguiente paso
    if (currentStep < totalSteps) {
      handleStepChange(currentStep + 1);
    }
  };

  const goToPreviousStep = (newData = {}) => {
    // Guardar datos solo si hay algún nuevo dato relevante
    if (newData) {
      setFormData((prevData) => ({
        ...prevData,
        ...newData,
      }));
    }
    // Retroceder al paso anterior
    if (currentStep > 1) {
      handleStepChange(currentStep - 1);
    }
  };

  // Renderización del componente basado en el paso actual
  const StepComponent = STEPS.find((step) => step.id === currentStep).component;

  if (isLoadingFlags) {
    return <></>;
  }

  return (
    <div className="financiar-wizard-container">
      {/* Barra de navegación de pasos */}
      <StepNav steps={STEPS} currentStep={currentStep} totalSteps={totalSteps} />

      {/* Contenido del wizard basado en el paso actual */}
      <StepComponent onNextStep={goToNextStep} onPreviousStep={goToPreviousStep} data={formData} />
    </div>
  );
};

export default FinanciarWizard;
